import { getToken } from "../../utils/authn";

// Use native fetch with manual retry logic instead of fetch-retry package
const retryFetch = async (url, options = {}, retries = 4) => {
  const { retryDelay, ...fetchOptions } = options;
  
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const response = await fetch(url, fetchOptions);
      
      // Retry on 429 (Too Many Requests)
      if (response.status === 429 && attempt < retries) {
        const delay = Math.pow(2, attempt) * 1000;
        console.warn(`[retryFetch] Got 429, retrying after ${delay}ms`);
        await new Promise(resolve => setTimeout(resolve, delay));
        continue;
      }
      
      return response;
    } catch (error) {
      console.warn(`[retryFetch] Attempt ${attempt + 1} failed:`, error.message);
      
      if (attempt < retries) {
        const delay = Math.pow(2, attempt) * 1000;
        console.warn(`[retryFetch] Retrying after ${delay}ms`);
        await new Promise(resolve => setTimeout(resolve, delay));
      } else {
        throw error;
      }
    }
  }
};

const callApiWithRetry = (url, { headers, ...options } = {}) => {
  if (typeof fetch !== 'function') {
    return Promise.reject(new Error(`fetch is not available (type: ${typeof fetch})`));
  }

  const fetchOptions = {
    headers: headers || {},
    ...options,
    ...{ mode: "cors" }
  };

  const token = getToken();
  if (token) {
    fetchOptions.headers["Authorization"] = `Bearer ${token}`;
  }

  return retryFetch(url, fetchOptions, 4)
    .then(r => {
      if (r.ok) {
        return r.json();
      } else {
        return r.text().then(text => {
          const body = text ? JSON.parse(text) : undefined;
          const error = new Error();
          if (r.status) {
            error.status = r.status;
          }
          if (typeof body !== "undefined") {
            error.body = body.error;
          }
          throw error;
        });
      }
    })
    .catch(e => {
      throw e;
    });
};

export { callApiWithRetry };
